/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { RepaymentAmountResponse } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get PAYG Repayment Options
 */
export const getRepaymentAmount = (
  options?: SecondParameter<typeof backofficeRequest<RepaymentAmountResponse>>,
) => {
  return backofficeRequest<RepaymentAmountResponse>(
    { url: `/api/v1/payg/options/repayment`, method: "GET" },
    options,
  )
}
export type GetRepaymentAmountResult = NonNullable<
  Awaited<ReturnType<typeof getRepaymentAmount>>
>
